// extracted by mini-css-extract-plugin
module.exports = {"slider":"ContentBox_slider__2yZPb","rule":"ContentBox_rule__2P4nv","text":"ContentBox_text__LkevE"};